import { Component, ElementRef, ViewChild } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';
import { TypingInterval } from 'src/app/constants';

@Component({
  selector: 'app-app-name-text-filter',
  templateUrl: './app-name-text-filter.component.html',
  styleUrls: ['./app-name-text-filter.component.scss']
})
export class AppNameTextFilterComponent implements IFilterAngularComp {

  @ViewChild('eFilterText') eFilterText!: ElementRef;

  params: IFilterParams;

  filterText = '';

  typingTimer: any;

  doneTypingInterval = TypingInterval;

  destroySubscription = false;

  constructor() { }

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.filterText != null && this.filterText !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let passed = true;
    const val = this.filterText.toLowerCase();
    if (!val) {
      passed = false;
    }

    return passed;
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.filterText };
  }

  setModel(model: any) {
    this.filterText = model == null ? null : model.value;
  }

  onInputChanged() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {
      this.params.filterChangedCallback();
    }, this.doneTypingInterval);
  }

  destroy() {
    this.destroySubscription = true;
  }
}
